import $oauth2 from '@/services/oauth2/auth';

export default (Vue, options) => {
    Vue.oauth2 = Vue.observable($oauth2);
    Object.defineProperties(Vue.prototype, {
        $oauth2: {
            get: () => Vue.oauth2,
        },
    });

    $oauth2.setConfig(options.config);
    (options.providers || []).forEach(provider => $oauth2.addProvider(provider, (options.configProviders || {})[provider.name] || {}));
};
